import {
  LOADING_UI,
  UNLOADING_UI,
  SET_ERRORS,
  CLEAR_ERRORS, SHOW_SIDEBAR, HIDE_SIDEBAR
} from "../types";
import { ActionType, InitialStateUIType } from '../../typings/state'

const initialState: InitialStateUIType = {
  loading: false,
  error: false,
  message: '',
  messageLoading: null,
  showSidebar: false,
};

const UIReducer = function (state = initialState, action: ActionType) {
  switch (action.type) {
    case LOADING_UI:
      return {
        ...state,
        ...action.payload,
        loading: true,
      };
    case UNLOADING_UI:
      return {
        ...state,
        loading: false,
        messageLoading: null,
      };
    case SET_ERRORS:
      return {
        ...state,
        ...action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: false,
        message: "",
      };
    case SHOW_SIDEBAR:
      return {
        ...state,
        ...action.payload,
        showSidebar: true,
      };
    case HIDE_SIDEBAR:
      return {
        ...state,
        ...action.payload,
        showSidebar: false,
      };
    default:
      return state;
  }
}

export default UIReducer;
